import React from 'react';
import { I18n } from 'aws-amplify';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import LapDialog from '../../util/laplaceDialog.js';
import authCheck, { getCruiseSetting, putCruiseSetting, deleteCruiseSetting, getCanIAccessToFromAuthzdb, getCanIAccessAsSuperFromAuthzdb } from '../../util/callApi.js';
import CarouselMaker from './carouselMaker.js';
import MierukaPagenation from './mierukapagenation.js';
import TasteSelector from './tasteSelector.js';
import QueryStrUtil from '../../util/queryStrUtil.js';
import countSurrogateStr from '../../util/countSurrogateStr.js'
import { createMuiTheme } from '@material-ui/core/styles';
import { MAX_CRUISE_SCREEN_TITLE_NUM, MIN_CRUISE_SECONDS_NUM, MAX_CRUISE_SECONDS_NUM, ASSET_DEFAULT_SCREENS } from '../../../configures/val.js';

const myQueryStrUtil = new QueryStrUtil();

// 0: 正常, 1: ロード中, 2: 正常通信だがデータがない, -1: 通信できてない
const API_STATUS = {
  OK: 0,
  LOADING: 1,
  NO_AUTH: 2,
  NO_RESPONSE: -1
};

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#ffffff',
      main: '#d6d6d6',
      dark: '#a5a5a5',
      contrastText: '#666666',
    },
    secondary: {
      light: '#ffebdb',
      main: '#ffb8a9',
      dark: '#ff9f8b',
      contrastText: '#f62b00',
    },
  },
});
export default class CruiseSetting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cruiseSeconds: 0,
      screenNames:{},
      secondsError: ' mypageOkText',
      openDeleteDialog: false,
      openCarousel: false,
      isRegist: false, // 設定ボタンを押したあとに結果エリアを表示する/しない
      mwid: '',
      isDisabled: false,
      authzError: API_STATUS.LOADING,
      cruiseError: API_STATUS.LOADING,
      initCarouselNum: 0,
      selectedAssetId: ''// ユーザが選択した assetId。didMount でinitされます。
    };
    // 巡回設定。APIから返ってきた値がそのまま入る
    this.cruiseSetting = null;
    // 更新可能な巡回設定。cruiseSettingBlockMakerから更新される値のみを管理する
    this.editableCruiseSetting = {};
    this.imgSet = [];
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  checkQueryString = () => {
    const mierukaWebId = myQueryStrUtil.getParamContent('mwid');
    if (mierukaWebId !== '') {
      return {
        mierukaWebId: mierukaWebId
      };
    } else {
      const mierukaWebIdFromSitelist = myQueryStrUtil.getParamContent('cruise');
      if (mierukaWebIdFromSitelist !== '') {
        return {
          mierukaWebId: mierukaWebIdFromSitelist
        };
      }
      return {
        mierukaWebId: ''
      };
    }
  }
  updateCruiseSettingByAsset = (val) => {
    this.cruiseSetting.data.config.screens = [];
    for (let i = 0; i < ASSET_DEFAULT_SCREENS[val].screenSetting.length; i++) {
      //画面数が変化しても問題ないようにデフォルトの画面設定で作り直す
      const targetScreenSetting = ASSET_DEFAULT_SCREENS[val];
      const screenSetting = {
        asset: {
          assetId: targetScreenSetting.screenSetting[i].assetId,
          screenId: targetScreenSetting.screenSetting[i].screenId
        },
        title: targetScreenSetting.titleList[i],
        editable: {}
      };
      if (targetScreenSetting.titleList[i] === '') {
        screenSetting.editable.title = true;
      }
      this.cruiseSetting.data.config.screens.push(screenSetting);
      if (this.cruiseSetting.data.config.screens[i].hasOwnProperty('title')) {
        const editedTitleKey = 'mierukaCruiseSetting-' + targetScreenSetting.screenSetting[i].screenId;
        if (this.editableCruiseSetting.hasOwnProperty(editedTitleKey)) {
          // もしユーザが編集したデータ (this.editableCruiseSetting) があるなら、そちらを採用する
          this.cruiseSetting.data.config.screens[i].title = this.editableCruiseSetting[editedTitleKey];
        }
      }
    }
  }
  updateImgSet = () => {
    this.imgSet = [];
    const root = this.cruiseSetting.data.config.bucketPath;
    for (let i = 0; i < this.cruiseSetting.data.config.screens.length; i++) {
      let str = root + this.cruiseSetting.data.config.screens[i].asset.assetId + '/thumbnail/' + this.cruiseSetting.data.config.screens[i].asset.screenId + '.jpg';
      this.imgSet.push(str);
    }
  }
  extractEditableSetting = () => {
    const screens = this.cruiseSetting.data.config.screens;
    const leng = screens.length;
    for (let i = 0; i < leng; i++) {
      if (screens[i].hasOwnProperty('editable')) {
        if (screens[i].editable.hasOwnProperty('title')) {
          const name = 'mierukaCruiseSetting-' + screens[i].asset.screenId;
          this.editableCruiseSetting[name] = screens[i].title;
        }
      }
    }
  }
  async componentDidMount() {
    let retCruise = {};
    let queryObj = {};
    try {
      const authRet = await authCheck();
      if (authRet.result === 'NG') {
        console.log('now Cruiseng == authCheck');
        window.history.pushState('', '', '/');
        this.props.authStateChange('signIn');
        return;
      }
      queryObj = this.checkQueryString();
      // まずv1/amisuper/ で確認する
      const resultIsSuper = await getCanIAccessAsSuperFromAuthzdb();
      if (resultIsSuper.result === 'NG') {
          // 認可DBとつながっていない
          this.setState({
            cruiseError: API_STATUS.OK,
            authzError: API_STATUS.NO_RESPONSE,
            mwid: queryObj.mierukaWebId,
          });
          return;
      } else {
        if (!resultIsSuper.data.data.result) {
          // caniして突き合わせる
          const cani = await getCanIAccessToFromAuthzdb(queryObj.mierukaWebId);
          if (cani.result === 'NG') {
            // 認可DBとつながっていない
            this.setState({
              cruiseError: API_STATUS.OK,
              authzError: API_STATUS.NO_RESPONSE,
              mwid: queryObj.mierukaWebId,
            });
            return;
          }
          if (!cani.data.data.result) {
            // 認可ない
            this.setState({
              cruiseError: API_STATUS.OK,
              authzError: API_STATUS.NO_AUTH,
              mwid: queryObj.mierukaWebId,
            });
            return;
          }
        }
      }
      // 値として渡す
      retCruise = await getCruiseSetting(queryObj.mierukaWebId);
      if (retCruise.result === 'NG') {
        this.setState({
          cruiseError: API_STATUS.NO_RESPONSE,
          authzError: API_STATUS.OK,
          mwid: queryObj.mierukaWebId,
        });
        return;
      }
    } catch (error) {
      // けどサインアウトするはずだからこれはないと思うけれど
      console.log('error == componentDidMount == cruiseSetting.js');
      console.log(error);
      return;
    }
    this.cruiseSetting = retCruise.data;
    // 巡回設定のうち、編集可能な値はそれだけを抽出する
    this.extractEditableSetting();
    // カルーセル用の画像URLを集めたデータセットを更新する
    this.updateImgSet();
    this.setState({
      mwid: queryObj.mierukaWebId,
      authzError: API_STATUS.OK,
      cruiseError: API_STATUS.OK,
      cruiseSeconds : this.cruiseSetting.data.config.common.displayTime,
      selectedAssetId: this.cruiseSetting.data.config.assetId
    });
  }
  // 巡回設定秒数のエラー状態を確認する
  checkTitleError = () => {
    let result = false;
    // 各画面タイトルを確認する
    for (let key in this.editableCruiseSetting) {
      const strNum = this.editableCruiseSetting[key].length
      if (strNum > MAX_CRUISE_SCREEN_TITLE_NUM) {
        const srrStrNum = countSurrogateStr(this.editableCruiseSetting[key]);
        if (srrStrNum > MAX_CRUISE_SCREEN_TITLE_NUM) {
          result = true;
          return result;
        }
      } else if (strNum < 1) {
        result = true;
        return result;
      }
    }
    return result;
  }
  // 巡回設定秒数のエラー状態を確認する
  checkSecondsError = (value) => {
    let result = false;
    // 巡回秒数に入力されたデータが条件に合っているかを確認する
    if (value < MIN_CRUISE_SECONDS_NUM || value > MAX_CRUISE_SECONDS_NUM) {
      result = true;
      return result;
    }
    return result;
  }
  handleChange = event => {
    const {value, name} = event.target;
    if ('cruiseSeconds' === name) {
      let secondsError = ' mypageOkText';
      const isSecondDisabled = this.checkSecondsError(value);
      const isTitleDisabled = this.checkTitleError();
      if (value < MIN_CRUISE_SECONDS_NUM || value > MAX_CRUISE_SECONDS_NUM) {
        secondsError = ' mypageErrorText';
      }
      const isDisabled = (isSecondDisabled || isTitleDisabled);
      this.setState({
        [name]: value,
        secondsError,
        isDisabled,
      });
    }
  };
  // それぞれの子設定ブロックから呼ばれて、値を更新する
  updatePostCruiseSetting = (name, value) => {
    // 子からのデータはthis.editableCruiseSettingに入れておく
    // 変わるのはbuttonのstateだけ
    this.editableCruiseSetting[name] = value;
    const isSecondDisabled = this.checkSecondsError(this.state.cruiseSeconds);
    const isTitleDisabled = this.checkTitleError();
    const isDisabled = (isSecondDisabled || isTitleDisabled);
    this.setState({
      [name]: value,
      isDisabled
    });
  }
  makeParam = () => {
    let screenIds = [];
    let ret = {
      assetId: this.state.selectedAssetId,
      common: {
        displayTime: this.cruiseSetting.data.config.common.displayTime
      },
      screens: []
    };
    // 巡回秒数の更新
    ret.common.displayTime = this.state.cruiseSeconds;

    // editableなthis.cruiseSettingを抜き出す
    for (let key in this.editableCruiseSetting) {
      if (key.indexOf('mierukaCruiseSetting-') !== -1) {
        let scrnId = key.replace('mierukaCruiseSetting-','')
        screenIds.push(scrnId);
      }
    }
    const screens = this.cruiseSetting.data.config.screens;
    const leng = this.cruiseSetting.data.config.screens.length;
    // 既存の巡回設定と更新されたtitleを比較する
    // 更新されていない箇所の場合は既存のtitleをそのまま採用する
    for (let i = 0; i < leng; i++) {
      for (let j = 0; j < screenIds.length; j++) {
        if (screens[i].asset.screenId === screenIds[j]) {
          const keyName = 'mierukaCruiseSetting-' + screenIds[j];
          ret.screens.push({
            title: this.editableCruiseSetting[keyName],
            asset: {
              screenId: screenIds[j]
            }
          });
          break;
        } else {
          if (j === screenIds.length - 1) {
            // 既存の値をそのまま採用する
            ret.screens.push({
              title: screens[i].title,
              asset: {
                screenId: screens[i].asset.screenId
              }
            });
          }
        }
      }
    }
    return ret;
  }
  Entry = () => {
    const param = this.makeParam();
    putCruiseSetting(this.state.mwid, param);
    this.setState({
      isRegist: true,
      secondsError: ''
    });
  }
  async remove (mwid) {
    const authRet = await authCheck();
    if (authRet.result === 'NG') {
      return;
    }
    const retDelete = await deleteCruiseSetting(mwid);
    if (retDelete.result === 'NG') {
      return;
    } else {
      window.location.href='/mierukamanage';
    }
  }
  toOpen = () => {
    this.setState({
      openDeleteDialog: true
    });
  }
  toClose = () => {
    this.setState({
      openDeleteDialog: false
    });
  }
  toOpenCarousel = (num) => {
    this.setState({
      openCarousel: true,
      initCarouselNum: num
    });
  }
  toCloseCarousel = () => {
    this.setState({
      openCarousel: false,
      initCarouselNum: 0
    });
  }
  showEntryResult = () => {
    return(
      <div className='mierukaCruiseSettingsMessage'>
        <p>{I18n.get('Cruise Setting is done. you can confirm via below link.')}</p>
        <Link className="mierukaNormalButton blue" to={{
          pathname: '/mierukamanage',
          state: {entryOk: true}
        }}>
          {I18n.get('Mieruka Web Setting')}
        </Link>
      </div>
    );
  }
  // 4文字
  breakMwid = (str, num) => {
    // strを4文字ごとに切り出して配列に入れる
    let arr = [];
    let res = 'MWID';
    for (let i = 0; i*num < str.length; i++) {
      let start = i * num;
      arr.push(str.substr(start, num));
    }
    // 配列を回して、途中にハイフンを入れる
    for (let j = 0; j < arr.length; j++) {
      res += '-' + arr[j];
    }
    return res;
  }
  changeTaste = (e) => {
    const {value} = e.target;
    this.updateCruiseSettingByAsset(value);
    this.updateImgSet();
    this.setState({
      selectedAssetId: value
    });
  }
  showTasteSelector = () => {
    if (this.cruiseSetting.data.config.premium) {
      return (
        <TasteSelector assetId={'customized_screen'} isDisabled={true} />
      );
    }
    return (
      <TasteSelector assetId={this.state.selectedAssetId} changeTaste={this.changeTaste} isDisabled={false} />
    );
  }
  showDeleteArea = () => {
    if (this.cruiseSetting.data.config.version > 1 || this.cruiseSetting.data.config.premium) {
      return (<div />);
    }
    if (this.cruiseSetting.data.config.deletable) {
      return (
        <div>
          <p className='mypageTitle'><span className='mypageTitleIcon'></span>{I18n.get('Delete')}</p>
          <div className='mypageUserinfoItem clearfix'>
            <p className='deletePRContents'>{I18n.get('Delete above PR contents.')} ({this.cruiseSetting.data.config.screens.length} {I18n.get('screens')})</p>
            <Button className='mypageLargeButton red' onClick={this.toOpen} variant='contained'>
              {I18n.get('Delete')}
            </Button>
          </div>
        </div>
      );
    } else {
      // バージョンが1以下
      // プレミアムではない
      // deletableがfalseのとき
      return (<div />);
    }
  }
  render() {
    if (this.state.authzError === API_STATUS.LOADING || this.state.cruiseError === API_STATUS.LOADING) {
      return (
        <div className='mypageContainer mierukaCruiseSettings'>
          <p className='mypageDescription'>{I18n.get('Now loading...')}</p>
        </div>
      );
    }else if (this.state.authzError === API_STATUS.NO_AUTH) {
      return (
        <div className='mypageContainer mierukaCruiseSettings'>
          <p className='mypageDescription'>{I18n.get('Editable cruise config is not found.')}</p>
        </div>
      );
    } else if (this.state.authzError === API_STATUS.NO_RESPONSE) {
      return (
        <div className='mypageContainer mierukaCruiseSettings'>
          <p className='mypageDescription'>{I18n.get('Authorization check is failed.')}</p>
        </div>
      );
    }
    if (this.state.cruiseError === API_STATUS.NO_RESPONSE) {
      return (
        <div className='mypageContainer mierukaCruiseSettings'>
          <p className='mypageDescription'>{I18n.get('Failed to get cruise config.')}</p>
        </div>
      );
    }
    if (this.state.mwid === '') {
      return (
        <div className='mypageContainer mierukaCruiseSettings'>
          <p className='mypageDescription'>{I18n.get('Cruise config is not found.')}</p>
        </div>
      );
    }
    if (this.cruiseSetting) {
      const dispId = this.breakMwid(this.state.mwid, 4);
      const secondsClassName = 'cruiseSettingBlockMaker cruiseSeconds' + this.state.secondsError;
      return (
        <div className='mypageContainer mierukaCruiseSettings'>
          <div className='mypageBreadcrumbs'>
           <Link to='/servicelist'>{I18n.get('Service list')}</Link>&nbsp;&nbsp;＞&nbsp;&nbsp;<Link to='/mierukamanage'>{I18n.get('Mieruka Web')}</Link>&nbsp;&nbsp;＞&nbsp;&nbsp;{I18n.get('Cruise config')}
          </div>
          <div>
            <p className='mypageTitle'>
              <span className='mypageTitleIcon'></span>
              {I18n.get('Cruise config')}
            <span className='mierukaTrackingCode'>
              {I18n.get('Service Tag')}:{dispId}
            </span>
            </p>
            <dl className='mypageUserinfoItem'>
              <div className='mierukaInputFlex mierukaScreenTaste'>
                <dt>
                  <Typography variant='subheading' gutterBottom>
                    {I18n.get('Screen taste')}
                  </Typography>
                </dt>
                {this.showTasteSelector()}
              </div>
              <div className='mierukaInputFlex'>
              <dt>
                <Typography variant='subheading' gutterBottom>
                  {I18n.get('Cruise time (sec)')}
                </Typography>
              </dt>
              <dd>
                <span className='mierukaCruiseTimeStyle'>{I18n.get('Each screen')}</span>
                <input
                  className='mypageInputStyle'
                  name='cruiseSeconds'
                  id='cruiseSeconds'
                  type='number'
                  min = '10' max = '3600'
                  placeholder={I18n.get('Enter cruise time (sec).')}
                  value={this.state.cruiseSeconds}
                  onChange={this.handleChange}
                />
                <span className='marLeft8'>{I18n.get('sec')}</span>
                <span className="changeableIcon fontSizeSmall">{I18n.get('EDITABLE')}</span>
                <p className={secondsClassName}>{I18n.get('You can set cruise seconds from 10 sec to 3,600sec.')}</p>
              </dd>
              </div>
              <MierukaPagenation
                toOpenCarousel={this.toOpenCarousel}
                updateChildState={this.updateChildState}
                content={this.cruiseSetting.data.config.screens}
                updatePostCruiseSetting={this.updatePostCruiseSetting}
                imgSet={this.imgSet}
              />
              <Button className='mypageLargeButton blue' onClick={this.Entry} variant='contained' color='secondary' disabled={this.state.isDisabled}>
                {I18n.get('Submit')}
              </Button>
              {this.state.isRegist ? this.showEntryResult() : <div />}
            </dl>
          </div>
          {this.showDeleteArea()}
          <LapDialog
            title={I18n.get('Delete PR screens')}
            contentElem={
              <div>
                {I18n.get('Do you delete below PR contents?')}<br />
                <ul><li>{this.cruiseSetting.data.config.screens[0].title}</li></ul>
              </div>
            }
            theme={theme}
            firstButtonText={I18n.get('Cancel')}
            firstButtonFunc={this.toClose}
            secondButtonText={I18n.get('Delete')}
            secondButtonFunc={() => this.remove(this.state.mwid)}
            open={this.state.openDeleteDialog}
            toClose={this.toClose}
          />
          <LapDialog
            contentElem={<CarouselMaker imgSet={this.imgSet} screens={this.cruiseSetting.data.config.screens} initNum={this.state.initCarouselNum} />}
            open={this.state.openCarousel}
            firstButtonFunc={this.toCloseCarousel}
            toClose={this.toCloseCarousel}
          />
        </div>
      );
    } else {
      // ここに入るかな。基本的にはcruiseError === noresponse で弾いてるからここに来ないはず
      return(
        <h1>{I18n.get('Now loading...')}</h1>
      );
    }
  }
}
